<po-modal [p-title]="title" p-size="xl" [p-primary-action]="closeAction">
  <div class="file-findings__source">
    <span class="po-icon po-icon-document file-findings__source-icon" aria-hidden="true"></span>
    <div class="file-findings__source-text">
      <span class="po-font-text-small file-findings__source-label">Fonte</span>
      <span class="po-font-text-large-bold file-findings__source-name">{{ fileName }}</span>
      <span class="po-font-text-small file-findings__source-folder" *ngIf="folder">{{ folder }}</span>
    </div>
    <po-button class="file-findings__copy" p-kind="tertiary"
      [p-icon]="copied ? 'po-icon po-icon-ok' : 'po-icon po-icon-copy'"
      [p-label]="copied ? 'Copiado' : 'Copiar caminho'"
      (p-click)="copyPath()"></po-button>
  </div>

  <div class="file-findings__summary" *ngIf="summary.length || scopeLabel">
    <po-tag *ngFor="let tag of summary" [p-value]="tag.label" [p-type]="tag.type" p-inverse="true"></po-tag>
    <span class="po-font-text-small">{{ scopeLabel }}</span>
  </div>

  <div class="file-findings__filter" *ngIf="filterButtons.length">
    <po-button-group [p-buttons]="filterButtons" p-toggle="single" p-small="true"></po-button-group>
  </div>

  <div class="file-findings__loading" *ngIf="loading">
    <po-loading-overlay></po-loading-overlay>
  </div>
  <p *ngIf="loadError" class="po-font-text">Não foi possível carregar os achados deste fonte.</p>
  <p *ngIf="!loading && !loadError && !blocks.length" class="po-font-text">Nenhum review deste fonte no recorte.</p>

  <po-accordion *ngIf="blocks.length" p-show-manager-accordion="true" p-allow-expand-all-items="true">
    <po-accordion-item *ngFor="let block of blocks"
      [p-label]="block.label"
      [p-label-tag]="block.tag"
      [p-type-tag]="block.tagType">

      <div class="file-findings__toolbar">
        <po-tag *ngIf="block.verdict" p-label="Veredito" [p-value]="block.verdict" [p-type]="block.verdictType"></po-tag>
        <po-button p-kind="secondary" p-icon="po-icon po-icon-eye" p-label="Abrir review"
          (p-click)="openReview(block)"></po-button>
      </div>

      <p *ngIf="block.note" class="po-font-text file-findings__note">{{ block.note }}</p>
      <p *ngIf="filteredOut(block)" class="po-font-text file-findings__note">Nenhum achado deste tipo neste review.</p>

      <ul class="file-findings__list" *ngIf="visibleFindings(block).length">
        <li class="file-findings__card" *ngFor="let finding of visibleFindings(block)">
          <div class="file-findings__meta">
            <po-tag [p-value]="finding.tag" [p-type]="finding.tagType" p-inverse="true"></po-tag>
            <span class="po-font-text-small">{{ finding.kind }} · {{ finding.line }}</span>
          </div>
          <div class="po-font-text file-findings__text" [innerHTML]="finding.description | markdown"></div>
          <pre class="file-findings__code" *ngIf="finding.code"><code>{{ finding.code }}</code></pre>
          <div class="file-findings__action" *ngIf="finding.action">
            <span class="po-font-text-small-bold">O que fazer</span>
            <div class="po-font-text file-findings__text" [innerHTML]="finding.action | markdown"></div>
          </div>
        </li>
      </ul>
    </po-accordion-item>
  </po-accordion>
</po-modal>
